import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ZoomCallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Get the code from the URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (code) {
      // Send the code to your backend to exchange for an access token
      axios.post('/sabbath/register', { zoomAuthorizationCode: code })
        .then(response => {
          // Handle success response
         // console.log('Zoom registration success', response.data);
          navigate('/success');
        })
        .catch(error => {
          // Handle error response
          console.error('Error registering to Zoom:', error);
          navigate('/error');
        });
    } else {
      // Handle error if there's no authorization code
      navigate('/error');
    }
  }, [navigate]);

  return (
    <div>
      <h2>Connecting to Zoom...</h2>
    </div>
  );
};

export default ZoomCallbackPage;
